/**
 * api接口统一管理
 */
import {axiosInstance} from "./http";
//幻灯片 classification: 'portal'
export const getCarousel = (obj) => axiosInstance.get('/blade-website/carousel/list',{params:obj})


//小程序配置
export const getConfig = (obj) => axiosInstance.get('/blade-website/config',{params:obj})





/**
 * 网站首页分类
 * @param obj
 */
export const getWebHomeClassify = () => axiosInstance.get('/education-api/course/classify-grade/web-home-classify')


/**
 * 首页随机查询课程
 * @param obj
 */
export const getHomeCourseList = (params) => axiosInstance.get('/education-api/course/home-list', {params})










